<h3 class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>
<div class="content">
  <div class="scroll-wrapper ui basic segment" [ngClass]="{ loading: pendingArr?.length }">
    <div *ngIf="success || error" tamsyMargin marginY="10px">
      <esl-message-toast [(message)] = "success" [messageType] = "success" ></esl-message-toast>
      <esl-message-toast [(message)] = "error"></esl-message-toast>
    </div>
    <!--Laboratory form  -->
    <div class="flex-blue">
      <img src="assets/icons/blue_info.svg" />
      <div>
        Please provide the names of the individuals responsible for bid submission and attendance at the bid opening for this lot before generating slip. 
      </div>
    </div>
    <div class="ui form" [formGroup]="lotForm">
      <h3 class="ui primary header">Bid Submission Contact Person</h3>
      <div class="field" [ngClass]="displayFieldCss('afirstName')">
        <label class="required">First Name</label>
        <input
          formControlName="afirstName"
          type="text"
          placeholder="Enter First Name"
        />
        <app-field-error-display
          [displayError]="isFieldValid('afirstName')"
          errorMsg="Please enter first name"
        >
        </app-field-error-display>
        <div
          class="data-error"
          *ngIf="
            !lotForm.get('afirstName')?.valid && lotForm.get('afirstName')?.touched
          "
        ></div>
      </div>    
      <div class="field" [ngClass]="displayFieldCss('alastName')">
        <label class="required">Last Name</label>
        <input
          formControlName="alastName"
          type="text"
          placeholder="Enter Last Name"
        />
        <app-field-error-display
          [displayError]="isFieldValid('alastName')"
          errorMsg="Please enter Last name"
        >
        </app-field-error-display>
        <div
          class="data-error"
          *ngIf="
            !lotForm.get('alastName')?.valid && lotForm.get('alastName')?.touched
          "
        ></div>
      </div>    
      <div class="field" [ngClass]="displayFieldCss('aphoneNumber')">
        <label class="required">Phone Number</label>
        <input
          formControlName="aphoneNumber"
          type="text"
          placeholder="Enter Phone Number"
        />
        <app-field-error-display
          [displayError]="isFieldValid('aphoneNumber')"
          errorMsg="Please enter Phone Number"
        >
        </app-field-error-display>
        <div
          class="data-error"
          *ngIf="
            !lotForm.get('aphoneNumber')?.valid && lotForm.get('aphoneNumber')?.touched
          "
        ></div>
      </div>    
      <div class="field" [ngClass]="displayFieldCss('adesignation')">
        <label class="required">Designation</label>
        <input
          formControlName="adesignation"
          type="text"
          placeholder="Enter Designation"
        />
        <app-field-error-display
          [displayError]="isFieldValid('adesignation')"
          errorMsg="Please enter Designation"
        >
        </app-field-error-display>
        <div
          class="data-error"
          *ngIf="
            !lotForm.get('adesignation')?.valid && lotForm.get('adesignation')?.touched
          "
        ></div>
      </div>    
      <h3 class="ui primary header">Bid Opening Contact Person</h3>

      <div class="field" [ngClass]="displayFieldCss('bfirstName')">
        <label class="required">First Name</label>
        <input
          formControlName="bfirstName"
          type="text"
          placeholder="Enter First Name"
        />
        <app-field-error-display
          [displayError]="isFieldValid('bfirstName')"
          errorMsg="Please enter first name"
        >
        </app-field-error-display>
        <div
          class="data-error"
          *ngIf="
            !lotForm.get('bfirstName')?.valid && lotForm.get('bfirstName')?.touched
          "
        ></div>
      </div>    
      <div class="field" [ngClass]="displayFieldCss('blastName')">
        <label class="required">Last Name</label>
        <input
          formControlName="blastName"
          type="text"
          placeholder="Enter Last Name"
        />
        <app-field-error-display
          [displayError]="isFieldValid('blastName')"
          errorMsg="Please enter Last name"
        >
        </app-field-error-display>
        <div
          class="data-error"
          *ngIf="
            !lotForm.get('blastName')?.valid && lotForm.get('blastName')?.touched
          "
        ></div>
      </div>    
      <div class="field" [ngClass]="displayFieldCss('bphoneNumber')">
        <label class="required">Phone Number</label>
        <input
          formControlName="bphoneNumber"
          type="text"
          placeholder="Enter Phone Number"
        />
        <app-field-error-display
          [displayError]="isFieldValid('bphoneNumber')"
          errorMsg="Please enter Phone Number"
        >
        </app-field-error-display>
        <div
          class="data-error"
          *ngIf="
            !lotForm.get('bphoneNumber')?.valid && lotForm.get('bphoneNumber')?.touched
          "
        ></div>
      </div>    
      <div class="field" [ngClass]="displayFieldCss('bdesignation')">
        <label class="required">Designation</label>
        <input
          formControlName="bdesignation"
          type="text"
          placeholder="Enter Designation"
        />
        <app-field-error-display
          [displayError]="isFieldValid('bdesignation')"
          errorMsg="Please enter Designation"
        >
        </app-field-error-display>
        <div
          class="data-error"
          *ngIf="
            !lotForm.get('bdesignation')?.valid && lotForm.get('bdesignation')?.touched
          "
        ></div>
      </div>    
    </div>
  </div>
</div>

<div class="actions">
  <button class="ui basic primary button" [disabled]="clicked" (click)="modal.deny(undefined)">
    Cancel
  </button>
  <button
    class="ui primary button"
    [ngClass]="{ yellow: pendingArr?.length }"
    [disabled]="!lotForm.valid || clicked"
    (click)="print(); clicked = true;"
    autofocus
  >
    Print Slip
  </button>
</div>
